import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { makeRestApiRequest, RestApiRequestConfig } from '~src/httpClient/RestApiService';

import { IGetIntegrationsForSiteParams } from '../../types/credentials/IGetIntegrationsForSiteParams';
import { IGetIntegrationsForSiteResponse } from '../../types/credentials/IGetIntegrationsForSiteResponse';

// The admin-only twin is gated behind siteIntegrationsAdminApiEnabled so the cutover can be
// flipped per-environment (W-21349725). Falls back to the public endpoint when the flag is off.
function siteIntegrationsEndpoint(): string {
  return FeatureFlags.siteIntegrationsAdminApiEnabled
    ? 'integrations/adminSiteIntegrations'
    : 'integrations/siteIntegrations';
}

export function getSlackIntegrationsForSite(params: IGetIntegrationsForSiteParams): Promise<IGetIntegrationsForSiteResponse> {
  const config: RestApiRequestConfig<{}, IGetIntegrationsForSiteParams> = {
    restApiVersion: '-',
    httpMethod: 'GET',
    endpoint: siteIntegrationsEndpoint(),
    serverWideRequest: true,
    queryParams: params,
    requestBody: {},
  };

  return makeRestApiRequest<{}, IGetIntegrationsForSiteResponse, IGetIntegrationsForSiteParams>(config);
}

export function getMsTeamsIntegrationsForSite(params: IGetIntegrationsForSiteParams): Promise<IGetIntegrationsForSiteResponse> {
  const config: RestApiRequestConfig<{}, IGetIntegrationsForSiteParams> = {
    restApiVersion: '-',
    httpMethod: 'GET',
    endpoint: siteIntegrationsEndpoint(),
    serverWideRequest: true,
    queryParams: params,
    requestBody: {},
  };

  return makeRestApiRequest<{}, IGetIntegrationsForSiteResponse, IGetIntegrationsForSiteParams>(config);
}
